// extracted by mini-css-extract-plugin
export var redoItem = "_ns-1";
export var redoTrigger = "_ns-0";